import { useLayoutEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";
import {
  isSignedInFreeOnPlanos,
  usePlanosVisitorProfile,
} from "../components/PublicChrome/freePlanosShell";
import PublicHeader from "../components/PublicChrome/PublicHeader";
import PublicShell from "../components/PublicChrome/PublicShell";
import PublicSiteFooter from "../components/PublicChrome/PublicSiteFooter";
import { mountPublicFonts, PUBLIC_FONT_FAMILY } from "../components/PublicChrome/publicFontFamily";
import { showsSharedPublicChrome } from "../components/PublicChrome/publicLayoutChrome";

const Page = styled.div`
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  width: 100%;
  flex: 1;
  min-height: auto;
`;

export default function PublicLayout() {
  const { pathname } = useLocation();
  const profile = usePlanosVisitorProfile(pathname);
  const signedInFree = isSignedInFreeOnPlanos(pathname, profile);

  // useLayoutEffect still installs the sheet before paint on a public route.
  // The dependency removes the sheet if the profile resolves to signed-in-free
  // after the first paint.
  useLayoutEffect(() => (signedInFree ? undefined : mountPublicFonts()), [signedInFree]);

  if (showsSharedPublicChrome(pathname) && !signedInFree) {
    return (
      <PublicShell>
        <div className="flex min-h-dvh flex-col" style={{ fontFamily: PUBLIC_FONT_FAMILY }}>
          <PublicHeader />
          <main className="w-full flex-1">
            <Outlet />
          </main>
          <PublicSiteFooter />
        </div>
      </PublicShell>
    );
  }

  return (
    <Page {...(signedInFree ? {} : { style: { fontFamily: PUBLIC_FONT_FAMILY } })}>
      <Content>
        <Outlet />
      </Content>
    </Page>
  );
}
